import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';

export function GatturiAssessmentHelp() {
    const pdfFile = '/gatturi-assessment-help.pdf';
    return (
        <div style={{ backgroundColor: 'white', paddingTop: '5vh', paddingBottom: '5vh' }}>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                <Viewer fileUrl={pdfFile} />
            </Worker>
        </div>
    );
}
